import styled from 'styled-components';
import media from '../../../styles/media.style';

import { BLACK, WHITE, NAVIGATION_MOBILE_HEIGHT, TEXT_GRAY } from '../../../styles/variables.style';

export const Anchor = styled.span`
  font-size: 14;
  line-height: 1.79;
  letter-spacing: 0.5px;
  color: ${BLACK};
  border-bottom: 1px solid ${BLACK};
  text-transform: uppercase;
`;

export const ErrorMessageWrapper = styled.div`
  // height: 18px;
  margin-bottom: 20px;
`;

export const Button = styled.button`
  width: 100%;
  height: 60px;
  background-color: ${BLACK};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${WHITE};
  margin-bottom: 40px;
  cursor: pointer;
  border: none;

  :disabled {
    background-color: #888888;
  }

  &.disabled {
    opacity: 0.3;
    cursor: default;
  }

  ${media.tabletP`
    letter-spacing: 0.8px;
  `};
`;

export const SignUpButton = Button.extend`
  margin-top: 75px;
`;

export const SignUpButtonWrapper = styled.div`
  width: 100%;
`;

export const ButtonPlaceholder = styled.div`
  margin-bottom: 40px;
`;

export const SignInLinkerWrapper = styled.div`
  width: 100%;
`;

export const InputWrapper = styled.div`
  flex: 1;
  margin: 15% 0;
  position: relative;
  ${media.tabletP`
    margin: 10% 0 40px;
  `};
`;

export const InputErrorMessage = styled.span`
  color: red;
  font-size: 12px;
  position: absolute;
  padding-top: 0.5rem;
`;

export const Input = styled.input`
  background: transparent;
  border: none;
  border-bottom: 2px solid ${BLACK};
  color: ${BLACK};
  font-size: 16px;
  letter-spacing: 0.1px;
  /*   flex: 1;
  margin: 15% 0; */
  padding-bottom: 5px;
  &::-webkit-input-placeholder {
    color: ${TEXT_GRAY.COMMON_1};
  }
  width: 100%;
  display: block;

  ${media.tabletP`
    font-size: 20px;
    /* margin: 10% 0 40px; */
  `};
`;

export const InputYearsExperience = Input.extend`
  margin: 15% 0 0;

  ${media.tabletP`
    margin: 15% 0;
  `};
`;

export const TermOfUseTextPlaceholderWrapper = styled.div`
  margin-bottom: 50px;
`;

export const TermOfUseText = styled.div`
  font-size: 14px;
  color: ${BLACK};
  // margin-bottom: 50px;
  display: flex;
  justify-content: space-between;

  > p {
    font-size: 14px;
  }
`;

export const Subtitle = styled.h3`
  font-size: 16px;
  line-height: 1.56;
  letter-spacing: 0.1px;
  color: ${BLACK};
`;

export const PlaceholderWrapper = styled.div`
  margin: 1em 0;
`;

export const Text = styled.p`
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${BLACK};
  text-align: left;
`;

export const TitleWrapper = styled.div`
  width: 100%;
`;

export const Title = styled.h1`
  font-size: 24px;
  line-height: 1.1;
  margin: 0;
  color: ${BLACK};
  text-transform: uppercase;
  margin-bottom: 40px;

  ${media.tabletP`
    font-size: 32px;
    font-weight: 500;
    line-height: 1.25;
    letter-spacing: 0.2px;
    margin-bottom: 40px;
  `};
`;

export const Wrapper = styled.div`
  background: ${WHITE};
  padding: 65px 20px;
  min-height: calc(100vh - ${NAVIGATION_MOBILE_HEIGHT}px);
  margin-top: 105px;

  ${media.tabletP`
    padding: 10% 15% 0;
  `};
`;

export const SelectWrapper = styled.div`
  position: relative;
  background-color: transparent;
  border: none;
  height: 100%;
  padding: 0;
  width: 100%;
  max-width: 260px;
  text-align: left;
  letter-spacing: 1px;
  border-bottom: 2px solid ${BLACK};
  margin-bottom: 0;

  ${media.tabletP`
      min-width: 120px;
  `};

  select {
    width: 100%;
    appearance: none;
    background: transparent;
    border: none;
    font-size: 16px;
    font-weight: 400;
    color: ${BLACK};

    ::-ms-expand {
      display: none;
    }

    ${media.tabletP`
      font-size: 20px;
    `};
  }

  ::before {
    content: '';
    position: absolute;
    top: 55%;
    right: 10px;
    transform: translateY(-50%) rotate(135deg);
    transform-origin: 6px 4px;
    width: 8px;
    height: 8px;
    border-top: 1px solid ${BLACK};
    border-right: 1px solid ${BLACK};
    transition: transform 0.3s;

    ${media.tabletP`
      right: 10px;
    `};
  }
`;

export const PageContent = styled.div`
  form {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    ${media.tabletP`
      flex-direction: row;
      margin-top: 60px;
    `};
  }
`;

export const LeftFields = styled.div`
  flex: 1;
`;

export const RightFields = styled.div`
  flex: 1;

  ${media.tabletP`
    margin-left: 90px;
  `};
`;

export const CountryCityWrapper = styled.div`
  display: flex;

  > div {
    flex: 1;
    margin-right: 10px;
    margin-bottom: 0;

    ${media.tabletP`
      margin-bottom: 15px;
    `};

    &:last-child {
      margin-right: 0px;
    }
  }

  input {
    flex: 1;
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const Spinner = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;

  ::after {
    content: ' ';
    display: block;
    width: 15px;
    height: 15px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: spinner 1.2s linear infinite;
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(51, 51, 51, 0.8);
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

export const OverlayModal = styled.div`
  position: relative;
  padding: 6em 120px;
  background-color: #fff;
  max-width: 600px;
`;

export const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;
  cursor: pointer;
  appearance: none;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 34px;
`;

export const ErrorMessage = styled.div`
  color: #f00;
  margin-bottom: 20px;
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SignUpPage/SignUpPage.style.js